import React from 'react';
import { BodyCard } from 'Common/components/Molecules/BodyCard';
import { Flex } from 'Common/components/Atoms/Flex';
import { FontIcon } from 'Common/components/Atoms/FontIcon';
import { Link } from 'Common/components/Atoms/Link';
import { PageContainer } from 'Common/components/Templates/PageContainer';
import { Text } from 'Common/components/Atoms/Text';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { useTheme } from '@mui/material/styles';
import { User } from '../../../models/User';
import { Email } from 'constants/email';
import { mail } from 'fluent-mailto';

export function Success({ user }: { user: User }): JSX.Element {
  const theme = useTheme();
  return (
    <PageContainer mt={6}>
      <Text variant="h2" textAlign="center" mb={4}>
        Welcome aboard, {user.name}!
      </Text>
      <BodyCard maxWidth={410} mx="auto">
        <Text variant="body1" textAlign="center" mb={6}>
          You're all set!
        </Text>
        <Flex
          background={theme.palette.success.dim}
          width={134}
          height={134}
          justifyContent="center"
          alignItems="center"
          m="auto"
          borderRadius="50%"
        >
          <FontIcon
            icon={faCheck}
            size="6x"
            color={theme.palette.success.main}
          />
        </Flex>
        <Text mt={6} textAlign="center" variant="body1">
          Your account information has been submitted for approval to
          PullRequest. A team member will reach out to you with next steps.
        </Text>
        <Text mt={4} textAlign="center" variant="body1">
          Questions? Please contact{' '}
          <Link href={mail.to(Email.SUPPORT).build()}>{Email.SUPPORT}</Link>
        </Text>
      </BodyCard>
    </PageContainer>
  );
}

export default Success;
